/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceDetailAdditionalInfo(data) {
    this.glass = Array.isArray(data?.glass) ? data.glass : [];
    this.ppsr = data?.ppsr || {};
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceDetailAdditionalInfo.blank = function () {
    return AssetFinanceDetailAdditionalInfo.build({
      glass: [],
      ppsr: {}
    });
  };

  AssetFinanceDetailAdditionalInfo.build = function (data) {
    return new AssetFinanceDetailAdditionalInfo(data);
  };

  AssetFinanceDetailAdditionalInfo.prototype.hasAdditionalInfo = function () {
    return !_.isEmpty(this.ppsr) || !_.isEmpty(this.glass);
  };

  return AssetFinanceDetailAdditionalInfo;
};
